<template>
    <div class="table-box">
        <div class="search-box">
            <Select v-model="model1"
                    style="width:240px;margin-right: 10px"
            >
                <Option :value="item.value"  v-for="item in courseArr" :key="item.value">{{item.title}}</Option>
            </Select>
            <Select v-model="model2"
                    style="width:140px;margin-right: 10px"
            >
                <Option :value="item.value"  v-for="item in classArr" :key="item.value">{{item.title}}</Option>
            </Select>
            <Select v-model="model3"
                    style="width:240px;margin-right: 10px"
            >
                <Option :value="item.value"  v-for="item in labArr" :key="item.value">{{item.title}}</Option>
            </Select>
            <Select v-model="model4"
                    style="width:140px;margin-right: 10px"
            >
                <Option :value="item.value"  v-for="item in statusArr" :key="item.value">{{item.title}}</Option>
            </Select>
            <Select v-model="model5"
                    style="width:140px;margin-right: 10px"
            >
                <Option :value="item.value"  v-for="item in stateArr" :key="item.value">{{item.title}}</Option>
            </Select>
            <Button type="primary" @click="createModal = true">查询</Button>
        </div>
        <Table ref="selection" :columns="columns" :data="datas" @on-select="tableSelect" @on-select-all="tableSelectAll"></Table>
    </div>
</template>

<script>
    export default {
        name: "labReport",
        data(){
            return{
                model1:'0',
                model2:'0',
                model3:'0',
                model4:'0',
                model5:'0',
                courseArr:[
                    {
                       value:'0',
                        title:'人工智能课程实训-AI 博弈平台开发'
                    },
                    {
                        value:'1',
                        title:'人工智能课程实训-智能交互式游戏开发 '
                    }
                ],
                classArr:[
                    {
                        value:'0',
                        title:'全部班级'
                    },
                    {
                        value:'1',
                        title:'人工智能体验一班'
                    }
                ],
                labArr:[
                    {
                        value:'0',
                        title:'全部实验'
                    },
                    {
                        value:'1',
                        title:'AI 博弈平台开发任务2：编写Python flask程序'
                    }
                ],
                statusArr:[
                    {
                        value:'0',
                        title:'全部状态'
                    },
                    {
                        value:'1',
                        title:'未提交'
                    },
                    {
                        value:'2',
                        title:'已提交'
                    }
                ],
                stateArr:[
                    {
                        value:'0',
                        title:'全部状态'
                    },
                    {
                        value:'1',
                        title:'未评分'
                    },
                    {
                        value:'2',
                        title:'已评分'
                    }
                ],
                datas: [

                ],
                columns: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: 'ID',
                        key: 'id',
                        width: 70,
                        sortable: true
                    },
                    {
                        title: '课程名称',
                        key: 'name',
                        sortable: true
                    },
                    {
                        title: '实验名称',
                        key: 'content'
                    },
                    {
                        title: '所属班级',
                        key: 'class'
                    },
                    {
                        title: '学生姓名',
                        key: 'stuName'
                    },
                    {
                        title: '学号',
                        key: 'stuId'
                    },
                    {
                        title: '提交时间',
                        key: 'stuId',
                        sortable: true
                    },
                    {
                        title: '提交状态',
                        key: 'status'
                    },
                    {
                        title: '评分',
                        key: 'score',
                        sortable: true
                    },
                    {
                        title: '操作',
                        key: 'action',
                        render: (h, params) => {
                            return h('div', [
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.showDetails(params.row)
                                        }
                                    }
                                }, '查看'),
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.deleteRow(params)
                                        }
                                    }
                                }, '删除'),
                            ]);
                        }
                    },
                ],
            }
        },
        methods: {
            ok(){

            },
            tableSelect(row){

            },
            tableSelectAll(row){

            },
        }
    }
</script>

<style scoped lang="less">
    @import "../../style/index";
</style>